import { horVertOrSquare } from "helpers";

type IOrientationName = "Landscape" | "Portrait" | "Square" | "Unknown";
type IOrientation = "horizontal" | "vertical" | "square" | "unknown";
const ORIENTATION_TO_LABEL_MAP: { [key: string]: IOrientationName } = {
  horizontal: "Landscape",
  vertical: "Portrait",
  square: "Square",
  unknown: "Unknown",
};
export const orientationByAspectRatio = (aspectRatios: {
  values: string[];
}) => {
  const values = aspectRatios?.values;
  if (!values?.length) return undefined;

  const groupedByOrient = {};

  const orientation: IOrientation | "" = values?.reduce<IOrientation | "">(
    (acc, value) => {
      let result: IOrientation | "";
      const [widthStr, heightStr] = value
        .replace(/_/g, "")
        .replace(/d0/g, "")
        .split("x");
      const width = parseInt(widthStr);
      const height = parseInt(heightStr);
      result = horVertOrSquare({ width, height });
      groupedByOrient[result] = groupedByOrient[result] || [];
      groupedByOrient[result].push(`${width}x${height}`);

      //if both vert and hor present, means conflicting orientations detected
      if (
        (acc === "horizontal" && result === "vertical") ||
        (acc === "vertical" && result === "horizontal")
      ) {
        result = "unknown";
      }

      if (result === "square" && !!acc) {
        //square is secondary orientation
        result = acc;
      }

      return result;
    },
    ""
  );

  return { name: ORIENTATION_TO_LABEL_MAP[orientation], groupedByOrient };
};
